/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/shield_lock_medium'
export default icon
